<hbox />
<hbox />
<hbox class="bottom center-bar" />
<hbox />
<hbox />

<style>
  .bottom {
    width: 28px;
    margin-block-start: -8px;
    border-bottom-left-radius: 32px;
    border-bottom-right-radius: 32px;
    background-color: var(--appbar-bg);
    color: var(--appbar-fg);
    z-index: -1;
  }
</style>
